<template>
  <div>
    <v-chip v-if="paid" color="green" text-color="white">
      <v-avatar left>
        <v-icon>mdi-checkbox-marked-circle</v-icon>
      </v-avatar>
      Ja
    </v-chip>

    <v-chip v-if="!paid" color="red" text-color="white">
      <v-avatar left>
        <v-icon>mdi-close-circle</v-icon>
      </v-avatar>
      Nei
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "OrderPaid",
  props: {
    paid: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
